import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/Officials.css"; // Custom CSS for styling

const Officials = () => {
    const testimonials = [
        {
            quote:
                "CLIF AI is solely responsible for getting me from practically minimum wage to over six figures a year.",
            name: "Winston S.",
            title: "Cloud Architect",
            image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cHJvZmVzc2lvbmFsfGVufDB8fDB8fHww", // Replace with actual image URL
        },
        {
            quote:
                "I can honestly say technology skills have saved my life... It’s given me the freedom to build my own career.",
            name: "Ryan C.",
            title: "IT Tech Specialist",
            image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHByb2Zlc3Npb25hbHxlbnwwfHwwfHx8MA%3D%3D", // Replace with actual image URL
        },
        {
            quote:
                "Before, I was an average developer who enjoyed my job, but today I can compete with anyone.",
            name: "Karoline K.",
            title: "Technical Supervisor",
            image: "https://images.unsplash.com/photo-1573496527892-904f897eb744?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fHByb2Zlc3Npb25hbHxlbnwwfHwwfHx8MA%3D%3D", // Replace with actual image URL
        },
    ];

    return (
        <div className="officials-section py-5">
            <Container>
                <Row>
                    {testimonials.map((testimonial, index) => (
                        <Col md={4} key={index} className="mb-4">
                            <div className="testimonial-card">
                                <div className="image-wrappers">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="rounded-circle"
                                    />
                                </div>
                                <p className="testimonial-quote">"{testimonial.quote}"</p>
                                <h5 className="testimonial-name">{testimonial.name}</h5>
                                <p className="testimonial-title">{testimonial.title}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default Officials;